import {
  Autocomplete,
  AutocompleteProps,
  createFilterOptions,
  Box,
  IconButton,
  InputAdornment,
  TextField,
  useTheme,
} from "@mui/material";
import {
  Cancel as CancelIcon,
  Search as SearchIcon,
} from "@mui/icons-material";
import { getSearchPlaceholder } from "~/lib/search-placeholder";

type Props = {
  id: string;
  searchFilters: string[];
  handleFilterQuery: AutocompleteProps<string, true, false, true>["onChange"];
  onDelete: (value: string) => void;
  placeholder?: string | null;
  onlyShowFilters?: boolean;
};

export function Search({
  id,
  searchFilters = [],
  handleFilterQuery,
  onDelete,
  placeholder,
  onlyShowFilters = false,
}: Props) {
  const filterOptions = createFilterOptions({
    trim: true,
  });
  const theme = useTheme();

  return (
    <Box sx={{ width: 1 }}>
      {!onlyShowFilters && (
        <Box component="form" noValidate sx={{ width: 1 }}>
          <Autocomplete
            id={`${id}-search`}
            freeSolo
            multiple
            options={[]}
            value={searchFilters}
            onChange={handleFilterQuery}
            renderTags={() => null}
            {...filterOptions}
            renderInput={(params) => (
              <TextField
                {...params}
                type="search"
                placeholder={getSearchPlaceholder(placeholder)}
                sx={{
                  background: theme.palette.code.background,
                  borderRadius: 1,
                  color: "text.primary",
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <SearchIcon sx={{ color: "text.secondary" }} />
                    </InputAdornment>
                  ),
                }}
              />
            )}
          />
        </Box>
      )}
      <Box>
        {searchFilters.map((value) => {
          return <KeyValueChip key={value} {...{ value, onDelete }} />;
        })}
      </Box>
    </Box>
  );
}

// copied from cicd-search.tsx
type KeyValueChipProps = {
  value: string;
  onDelete: (value: string) => void;
};

export function KeyValueChip({ value, onDelete }: KeyValueChipProps) {
  const label = `search: ${value}`;
  const chipSx = {
    display: "inline-flex",
    alignItems: "center",
    border: "1px solid",
    borderColor: "background.light",
    backgroundColor: "background.light",
    marginTop: 1,
    marginRight: 1,
    paddingRight: 1,
    borderRadius: 1,
    typography: "body2",
    cursor: "pointer",
    fontSize: "13px",
    overflowWrap: "anywhere",
  };
  const keySx = {
    backgroundColor: "background.paper",
    padding: 1,
    display: "inline-flex",
    alignSelf: "stretch",
    alignItems: "center",
  };
  const valSx = {
    backgroundColor: "background.light",
    padding: 1,
    display: "inline-flex",
    alignSelf: "stretch",
    alignItems: "center",
  };
  return (
    <Box sx={chipSx} aria-label={label}>
      <Box sx={keySx}>search:</Box>
      <Box sx={valSx}>{value}</Box>
      <IconButton onClick={() => onDelete(value)} sx={{ p: 0 }}>
        <CancelIcon sx={{ color: "text.primary", opacity: "0.26" }} />
      </IconButton>
    </Box>
  );
}
